import { render, staticRenderFns } from "./ModalVisualizaEstruturaAnoLetivo.vue?vue&type=template&id=c9f5abee"
import script from "./ModalVisualizaEstruturaAnoLetivo.vue?vue&type=script&lang=js"
export * from "./ModalVisualizaEstruturaAnoLetivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports